import { render, staticRenderFns } from "./ProcedureFilterCard.vue?vue&type=template&id=2983e5bb&scoped=true"
import script from "./ProcedureFilterCard.vue?vue&type=script&lang=js"
export * from "./ProcedureFilterCard.vue?vue&type=script&lang=js"
import style0 from "./ProcedureFilterCard.vue?vue&type=style&index=0&id=2983e5bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2983e5bb",
  null
  
)

export default component.exports